import type { SVGProps } from "react";

export default function ShareIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.25 10.0002L12.0833 5.8335M16.25 10.0002L12.0833 14.1668M16.25 10.0002H7.91667C6.52777 10.0002 3.75 10.8335 3.75 14.1668"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
